import ProtectedRoute from "./ProtectedRoute";
import {
  dashboardUrls,
  downloadableMaterial,
  liveClassUrls,
  studentUrls,
  materialUrls,
  newsUrls,
  one2OneTutoring,
  practiceHubUrls,
  roleUrls,
  staticPagesUrls,
  testUrls,
  userUrls,
  profileUrl,
  chapterUrls,
  subChapterUrls,
  subChapterQuestionUrls,
  simulatorUrls,
  blogUrls,
} from "../../Api/Auth/AppUrls";
import RoleList from "../../Pages/Admin/Roles";
import UserList from "../../Pages/Admin/Users";
import TestList from "../../Pages/Admin/Test";
import FeQuiz from "../../Pages/Admin/FE Quiz";
import FeModelTest from "../../Pages/Admin/FE Model Test";
import FeMaterial from "../../Pages/Admin/FE Material";
import PaidModelTest from "../../Pages/Admin/Paid Model Test";
import MaterialList from "../../Pages/Admin/Material";
import SubscriptionMaterials from "../../Pages/Admin/Subscription Materials";
import StaticHome from "../../Pages/Admin/Static Pages/StaticHome/StaticHome";
import StaticSinglePage from "../../Pages/Admin/Static Pages/StaticSinglePages/StaticSinglePage";
import NewsList from "../../Pages/Admin/News";
import TutoringIndex from "../../Pages/Admin/Tutoring";
import TutoringPackages from "../../Pages/Admin/Tutoring/TutoringPackages";
import SubTopicAdmin from "../../Pages/Admin/SubTopic";
import TopicAdmin from "../../Pages/Admin/Topic";
import PracticeHubIndex from "../../Pages/Admin/Practice Hub";
import LiveClassIndex from "../../Pages/Admin/LiveClass";
import LiveClasses from "../../Pages/Admin/LiveClass/LiveClasses";
import LiveClassItem from "../../Pages/Admin/LiveClass/LiveClassItems";
import StudentLiveClass from "../../Pages/Student/LiveClass";
import StudentSubscriptionMaterials from "../../Pages/Student/Subscription Materials";
import StudentPracticeHub from "../../Pages/Student/PracticeHub";
import StudentPaidModelTest from "../../Pages/Student/Paid Model Test";
import StudentTutoringIndex from "../../Pages/Student/Tutoring";
import TutoringPurchase from "../../Pages/Admin/Tutoring/TutoringPurchase";
import PracticeHubIndexMecha from "../../Pages/MechanicalAdmin/Practice Hub";
import SubscriptionMaterialsMecha from "../../Pages/MechanicalAdmin/Subscription Materials";
import MechanicalTutoringIndex from "../../Pages/Admin/Tutoring/Mechanical";
import MechanicalPaidModelTest from "../../Pages/MechanicalAdmin/Paid Model Test";
import FeMaterialMechanical from "../../Pages/MechanicalAdmin/FE Material";
import MechanicalFeModelTest from "../../Pages/MechanicalAdmin/FE Model Test";
import MechanicalLiveClassIndex from "../../Pages/MechanicalAdmin/LiveClass";
import StudentPracticeHubMechanical from "../../Pages/Student/PracticeHub/Mechanical";
import StudentLiveClassMechanical from "../../Pages/Student/LiveClass/Mechanical";
import StudentSubscriptionMaterialsMechanical from "../../Pages/Student/Subscription Materials/Mechanical";
import StudentPaidModelTestMechanical from "../../Pages/Student/Paid Model Test/Mechanical";
import StudentTutoringIndexMechanical from "../../Pages/Student/Tutoring/Mechanical";
import AdminDashboard from "../../Pages/Admin/Dashboard";
import Profile from "../../Pages/Profile";
import ChaptersList from "../../Pages/Admin/Chapters";
import SubChaptersList from "../../Pages/Admin/SubChapters";
import Questions from "../../Pages/Admin/Question";
import QuizBankIndex from "../../Pages/Admin/QuizBank";
import QuizBankIndexMecha from "../../Pages/MechanicalAdmin/Quiz Bank";
import StudentQuizBank from "../../Pages/Student/QuizBank";
import StudentDashboard from "../../Pages/Student/Dashboard";
import MechanicalStudentQuizBank from "../../Pages/Student/QuizBank/Mechanical";
import ModelTestList from "../../Pages/Admin/ModelTest";
import ModelTestQuestions from "../../Pages/Admin/Model Test Question";
import SimlulatorCivilIndex from "../../Pages/Admin/Simulator";
import SimlulatorMechaIndex from "../../Pages/MechanicalAdmin/Simulator";
import StudentSimulator from "../../Pages/Student/Simulator";
import MechanicalStudentSimulator from "../../Pages/Student/Simulator/Mechanical";
import StaticContact from "../../Pages/Admin/Static Pages/StaticContact/StaticContact";
import StaticFooterPages from "../../Pages/Admin/Static Pages/StaticFooterPages";
import StaticPrivacyPolicy from "../../Pages/Admin/Static Pages/StaticPrivacyPolicy";
import StaticTermsOfService from "../../Pages/Admin/Static Pages/StaticTermsOfService";
import BlogsList from "../../Pages/Admin/Blogs";
import FreeModelTestList from "../../Pages/Admin/ModelTest/FreeModelTest";

export const routes = [
  {
    route: dashboardUrls.admin,
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    route: profileUrl,
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
  },
  {
    route: roleUrls.list,
    element: (
      <ProtectedRoute>
        <RoleList />
      </ProtectedRoute>
    ),
  },
  {
    route: userUrls.list,
    element: (
      <ProtectedRoute>
        <UserList />
      </ProtectedRoute>
    ),
  },
  {
    route: testUrls.list,
    element: (
      <ProtectedRoute>
        <TestList />
      </ProtectedRoute>
    ),
  },
  {
    route: chapterUrls.list,
    element: (
      <ProtectedRoute>
        <ChaptersList />
      </ProtectedRoute>
    ),
  },
  {
    route: chapterUrls.pageCivil,
    element: (
      <ProtectedRoute>
        <QuizBankIndex />
      </ProtectedRoute>
    ),
  },
  {
    route: chapterUrls.pageMechanical,
    element: (
      <ProtectedRoute>
        <QuizBankIndexMecha />
      </ProtectedRoute>
    ),
  },
  {
    route: simulatorUrls.list,
    element: (
      <ProtectedRoute>
        <ModelTestList />
      </ProtectedRoute>
    ),
  },
  {
    route: simulatorUrls.freeModelTestTakers,
    element: (
      <ProtectedRoute>
        <FreeModelTestList />
      </ProtectedRoute>
    ),
  },
  {
    route: simulatorUrls.questions,
    element: (
      <ProtectedRoute>
        <ModelTestQuestions />
      </ProtectedRoute>
    ),
  },
  {
    route: simulatorUrls.pageCivil,
    element: (
      <ProtectedRoute>
        <SimlulatorCivilIndex />
      </ProtectedRoute>
    ),
  },
  {
    route: simulatorUrls.pageMechanical,
    element: (
      <ProtectedRoute>
        <SimlulatorMechaIndex />
      </ProtectedRoute>
    ),
  },

  {
    route: subChapterUrls.list,
    element: (
      <ProtectedRoute>
        <SubChaptersList />
      </ProtectedRoute>
    ),
  },
  {
    route: subChapterQuestionUrls.list,
    element: (
      <ProtectedRoute>
        <Questions />
      </ProtectedRoute>
    ),
  },
  {
    route: newsUrls.list,
    element: (
      <ProtectedRoute>
        <NewsList />
      </ProtectedRoute>
    ),
  },
  {
    route: blogUrls.list,
    element: (
      <ProtectedRoute>
        <BlogsList />
      </ProtectedRoute>
    ),
  },
  {
    route: downloadableMaterial.adminFreeFeQuiz,
    element: (
      <ProtectedRoute>
        <FeQuiz />
      </ProtectedRoute>
    ),
  },
  {
    route: downloadableMaterial.adminFreeModelTest,
    element: (
      <ProtectedRoute>
        <FeModelTest />
      </ProtectedRoute>
    ),
  },
  {
    route: downloadableMaterial.adminMechanicalFreeModelTest,
    element: (
      <ProtectedRoute>
        <MechanicalFeModelTest />
      </ProtectedRoute>
    ),
  },
  {
    route: downloadableMaterial.adminFreeMaterial,
    element: (
      <ProtectedRoute>
        <FeMaterial />
      </ProtectedRoute>
    ),
  },
  {
    route: downloadableMaterial.adminMechanicalFreeMaterial,
    element: (
      <ProtectedRoute>
        <FeMaterialMechanical />
      </ProtectedRoute>
    ),
  },
  {
    route: downloadableMaterial.adminPaidModelTest,
    element: (
      <ProtectedRoute>
        <PaidModelTest />
      </ProtectedRoute>
    ),
  },
  {
    route: downloadableMaterial.adminMechanicalPaidModelTest,
    element: (
      <ProtectedRoute>
        <MechanicalPaidModelTest />
      </ProtectedRoute>
    ),
  },
  {
    route: materialUrls.list,
    element: (
      <ProtectedRoute>
        <MaterialList />
      </ProtectedRoute>
    ),
  },
  {
    route: downloadableMaterial.adminSubscriptionMaterials,
    element: (
      <ProtectedRoute>
        <SubscriptionMaterials />
      </ProtectedRoute>
    ),
  },
  {
    route: downloadableMaterial.adminMechanicalSubscriptionMaterials,
    element: (
      <ProtectedRoute>
        <SubscriptionMaterialsMecha />
      </ProtectedRoute>
    ),
  },
  //static pages
  {
    route: staticPagesUrls.home,
    element: (
      <ProtectedRoute>
        <StaticHome />
      </ProtectedRoute>
    ),
  },
  {
    route: staticPagesUrls.home,
    element: (
      <ProtectedRoute>
        <StaticHome />
      </ProtectedRoute>
    ),
  },
  {
    route: staticPagesUrls.singlePage,
    element: (
      <ProtectedRoute>
        <StaticSinglePage />
      </ProtectedRoute>
    ),
  },
  {
    route: staticPagesUrls.contact,
    element: (
      <ProtectedRoute>
        <StaticContact />
      </ProtectedRoute>
    ),
  },
  {
    route: staticPagesUrls.privacyPolicy,
    element: (
      <ProtectedRoute>
        <StaticPrivacyPolicy />
      </ProtectedRoute>
    ),
  },
  {
    route: staticPagesUrls.termsOfService,
    element: (
      <ProtectedRoute>
        <StaticTermsOfService />
      </ProtectedRoute>
    ),
  },
  {
    route: staticPagesUrls.footer,
    element: (
      <ProtectedRoute>
        <StaticFooterPages />
      </ProtectedRoute>
    ),
  },
  //one two one
  {
    route: one2OneTutoring.pageCivil,
    element: (
      <ProtectedRoute>
        <TutoringIndex />
      </ProtectedRoute>
    ),
  },
  {
    route: one2OneTutoring.pageMechanical,
    element: (
      <ProtectedRoute>
        <MechanicalTutoringIndex />
      </ProtectedRoute>
    ),
  },
  {
    route: one2OneTutoring.packages,
    element: (
      <ProtectedRoute>
        <TutoringPackages />
      </ProtectedRoute>
    ),
  },
  {
    route: one2OneTutoring.purchase,
    element: (
      <ProtectedRoute>
        <TutoringPurchase />
      </ProtectedRoute>
    ),
  },
  {
    route: practiceHubUrls.adminSubTopicTopic,
    element: (
      <ProtectedRoute>
        <SubTopicAdmin />
      </ProtectedRoute>
    ),
  },
  {
    route: practiceHubUrls.adminTopic,
    element: (
      <ProtectedRoute>
        <TopicAdmin />
      </ProtectedRoute>
    ),
  },
  {
    route: practiceHubUrls.pageCivil,
    element: (
      <ProtectedRoute>
        <PracticeHubIndex />
      </ProtectedRoute>
    ),
  },
  {
    route: practiceHubUrls.pageMechanical,
    element: (
      <ProtectedRoute>
        <PracticeHubIndexMecha />
      </ProtectedRoute>
    ),
  },
  {
    route: liveClassUrls.pageCivil,
    element: (
      <ProtectedRoute>
        <LiveClassIndex />
      </ProtectedRoute>
    ),
  },
  {
    route: liveClassUrls.pageMechanical,
    element: (
      <ProtectedRoute>
        <MechanicalLiveClassIndex />
      </ProtectedRoute>
    ),
  },
  {
    route: liveClassUrls.liveClasses,
    element: (
      <ProtectedRoute>
        <LiveClasses />
      </ProtectedRoute>
    ),
  },
  {
    route: liveClassUrls.liveClassItem,
    element: (
      <ProtectedRoute>
        <LiveClassItem />
      </ProtectedRoute>
    ),
  },
];

export const studentRoutes = [
  {
    route: dashboardUrls.student,
    element: (
      <ProtectedRoute>
        <StudentDashboard />
      </ProtectedRoute>
    ),
  },

  {
    route: studentUrls.studentTutoring,
    element: (
      <ProtectedRoute>
        <StudentTutoringIndex />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentTutoringMechanical,
    element: (
      <ProtectedRoute>
        <StudentTutoringIndexMechanical />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.liveClass,
    element: (
      <ProtectedRoute>
        <StudentLiveClass />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.liveClassMechanical,
    element: (
      <ProtectedRoute>
        <StudentLiveClassMechanical />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentSubscriptionMaterials,
    element: (
      <ProtectedRoute>
        <StudentSubscriptionMaterials />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentSubscriptionMaterialsMechanical,
    element: (
      <ProtectedRoute>
        <StudentSubscriptionMaterialsMechanical />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentPracticeHub,
    element: (
      <ProtectedRoute>
        <StudentPracticeHub />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentPracticeHubMechanical,
    element: (
      <ProtectedRoute>
        <StudentPracticeHubMechanical />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentPaidModelTest,
    element: (
      <ProtectedRoute>
        <StudentPaidModelTest />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentPaidModelTestMechanical,
    element: (
      <ProtectedRoute>
        <StudentPaidModelTestMechanical />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentQuizBankCivil,
    element: (
      <ProtectedRoute>
        <StudentQuizBank />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentQuizBankMechanical,
    element: (
      <ProtectedRoute>
        <MechanicalStudentQuizBank />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentSimulatorCivil,
    element: (
      <ProtectedRoute>
        <StudentSimulator />
      </ProtectedRoute>
    ),
  },
  {
    route: studentUrls.studentSimulatorMechanical,
    element: (
      <ProtectedRoute>
        <MechanicalStudentSimulator />
      </ProtectedRoute>
    ),
  },
  {
    route: profileUrl,
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
  },
];
